// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__1WSYo","image":"Login_image__1S60U","content":"Login_content__1WbFh","form":"Login_form__JTcik","submit":"Login_submit__1B25t"};